import { get, post } from '@/api/request';

const URI = "/customer"

// 客户管理-客户列表
export const listClient = (page, size, params) => post(`${URI}/selectCustomer?page=${page}&size=${size}`, params);
// 客户管理-修改客户
export const updateRemark = params => post(`${URI}/updateRemark`, params);
// 客户管理-新增客户
export const saveClient = params => post(`${URI}/saveCustomer`, params);
// 客户管理-获取客户信息
export const getClient = id => get(`${URI}/info/${id}`);
// 客户管理-删除客户
export const delClient = id => get(`${URI}/deleteCustomer/${id}`);


// WEBPACK FOOTER //
// ./src/api/ticket/client.js